function toggleAnimation() {
  let elements = Array.from(document.querySelectorAll('[data-animate]'));
  for (var i = 0; i < elements.length; i += 1) {
    var el = elements[i];
    const scroll        = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const position      = el.parentNode.offsetTop;
    if (scroll + 280 > position) {
      if (!el.className.match(/active/)) {
        el.className += ` active`;
      }
    } else {
      el.className = el.className.replace(/\sactive/g, '');
    }
  }
}

document.addEventListener('turbolinks:load', () => {
  toggleAnimation();
  window.addEventListener('scroll', () => { toggleAnimation() });
});
